import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

// Component for fetching and displaying featured image
function FeaturedImage({ mediaId, title }) {
    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        if (mediaId) {
            wp.apiFetch({ path: `/wp/v2/media/${mediaId}` })
                .then((media) => setImageUrl(media.source_url))
                .catch((error) => console.error("Error fetching media:", error));
        }
    }, [mediaId]);

    return imageUrl ? <img src={imageUrl} alt={title.rendered} /> : null;
}

// Main box component
export default function light({ attributes, docSections, multiDocs, articlesNumber }) {

    const { col, docs_layout, readMoreText, orderBy, child_docs_order, show_topic, topic_label, sectionButton, sectionButtonText, btnURL, isFeaturedImage } = attributes;

    function ChildItems({ parentId, articlesNumber, onCountUpdate }) {
        const docItems = useSelect(
            (select) =>
                select("core").getEntityRecords("postType", "docs", {
                    per_page: articlesNumber || 10,
                    orderby: orderBy,
                    order: child_docs_order,
                    parent: parentId,
                    status: ["publish", "private"],
                }),
            [parentId, articlesNumber, orderBy, child_docs_order]
        );
        
        useEffect(() => {
            if (onCountUpdate) {
                onCountUpdate(docItems?.length || 0);
            }
        }, [docItems, onCountUpdate]);

        if (!docItems) return;
        if (docItems.length === 0) return <ul className="ezd-list-unstyled tag_list"><li><i className="icon_document_alt"></i><a className="ct-content-text">
            No child items available</a></li></ul>

        return (
            <>
            <ul className="ezd-list-unstyled tag_list">
                {docItems.map((item) => (
                    <li key={item.id}>
                        <i className="icon_document_alt"></i>
                        <a className="ct-content-text" href="#">
                            {item.title.rendered}
                        </a>
                    </li>
                ))}
            </ul>
        </>
        );
    }

    // Determine layout type
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    return (
    <>
        <div className={`${layoutType}`}>
            {(docSections || multiDocs) &&
                [...(docSections || []), ...(multiDocs || [])].map((section) => {
                    const { id, title, featured_media } = section;
                  
                    return (
                        <div key={id} className="categories_guide_item box-item wow fadeInUp single-doc-layout-one light-style" data-wow-delay="0.2s">
                          
                          {isFeaturedImage && (
                            <FeaturedImage mediaId={featured_media} title={title} />
                          )}
                            
                            <div className="doc-top ezd-d-flex ezd-align-items-start">
                                <a class="doc_tag_title" href="#">
                                    <h4 class="title"> {title.rendered} </h4>
                                    {show_topic && (
                                        <span class="ezd-badge"> {articlesNumber} {topic_label} </span>
                                    )}
                                </a>
                            </div>
                            
                            <ChildItems parentId={id} articlesNumber={articlesNumber} />
                            
                            {/* Read More Button */}
                            <a href="#" className="doc_border_btn">
                                {readMoreText} <i className="arrow_right"></i>
                            </a>
                        </div>
                    );
                })}
        </div>

        {sectionButton && (
            <div class="text-center">
                <a href={`${btnURL}`} class="action_btn all_doc_btn wow fadeinUp">
                    {sectionButtonText} <i class="arrow_right"></i>
                </a>
            </div>
        )}
    </>
    );
}